module.exports = __webpack_public_path__ + "static/media/firstPicture.ac4b0ee3.jpg";